import React from 'react';
import Hero from '../components/home_components/Hero';
import Services from '../components/home_components/Services';
import DoctorsCarousel from '../components/home_components/DoctorsCarousel';
import AboutUs from '../components/home_components/AboutUs';
import HealthPackages from '../components/home_components/HealthPackages';
import Testimonials from '../components/home_components/Testimonials';
import HealthcareServicesGrid from '../components/home_components/HealthcareServicesGrid';

const Home = () => {
  return (
    <>
      <Hero />
      <AboutUs />
      <Services />
      {/* <DoctorsCarousel/> */}
      <HealthPackages />
      <Testimonials />
      <HealthcareServicesGrid />
   
    </>
  );
};

export default Home;
